import { API_CONFIG } from '@/config/api';
import { httpClient } from '@/utils/httpClient';
import type { IeImportPayloadRow } from '@/components/iem/kits/ieImportFile';

export interface IeImportErrorDetail {
  rowNumber: number | null;
  column: string | null;
  message: string;
}

export interface IeImportPreviewRow {
  rowNumber: number;
  lin: string;
  nsn: string | null;
  nomenclature: string;
  quantity: number;
  optional: boolean;
  notes: string;
  catalogId: string;
  catalogDisplayName: string;
  status: 'valid';
}

export interface IeImportSummary {
  totalRows: number;
  validCount: number;
}

export interface IeImportResponse {
  success: boolean;
  validateOnly: boolean;
  summary: IeImportSummary;
  createdCount: number;
  updatedCount: number;
  preview: IeImportPreviewRow[];
  errors?: IeImportErrorDetail[];
}

class IeImportService {
  private endpoint = `${API_CONFIG.ACTIONS_API_BASE_PATH}/iem/ie-kit/import`;

  async validateImport(
    ieKitId: string,
    rows: IeImportPayloadRow[],
  ): Promise<IeImportResponse> {
    return httpClient.post<IeImportResponse>(this.endpoint, {
      ieKitId,
      rows,
      validateOnly: true,
    });
  }

  async applyImport(
    ieKitId: string,
    rows: IeImportPayloadRow[],
  ): Promise<IeImportResponse> {
    return httpClient.post<IeImportResponse>(this.endpoint, {
      ieKitId,
      rows,
      validateOnly: false,
    });
  }
}

export const ieImportService = new IeImportService();
